import React from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

const Pill = ({
	icon,
	name,
	theme,
	square,
	className
}) => {
	// Concat className with modifiers
	const cls = classnames(
		'h-6 px-2 max-w-fit tracking-wide text-sm font-semibold leading-6 transition-colors',
		!theme && 'bg-neutral-50 text-neutral-600 dark:bg-neutral-700 dark:text-white',
		theme === 'success' && 'bg-emerald-500 text-white',
		theme === 'warning' && 'bg-amber-500 text-white',
		theme === 'danger' && 'bg-red-500 text-white',
		theme === 'informative' && 'bg-indigo-500 text-white',
		square && 'rounded-lg',
		!square && 'rounded-full',
		// Currently disabled since windows makes them hidden by default
		// 'whitespace-nowrap text-ellipsis overflow-hidden',
		className
	);

	return (
		<div className={cls}>
			<Show if={icon}>
				<Icon icon={icon} className="mr-2" />
			</Show>

			{name}
		</div>
	);
};

export default Pill;
